import { AxiosResponse } from 'axios';
import jobBoardAPI from './base';
import {
  PermissionResponse,
  RoleDTO,
  RolePermissionsApiResponse,
  RoleResponse
} from 'pages/apps/roles/types/types';

export const roleEndpoints = {
  getAllRoles: '/roles/roles',
  getRoleById: '/roles/roles/:id',
  create: '/roles/roles',
  update: '/roles/roles/:id',
  delete: '/roles/roles/:id',
  getAllPermissions: '/permissions/permissions/categories',
  getRoleDetail: (roleId: string) => `/roles/roles/${roleId}`
};

export const GET_ALL_ROLES = async (): Promise<
  AxiosResponse<RoleResponse[]>
> => {
  const response = await jobBoardAPI.get(roleEndpoints.getAllRoles);
  return response.data;
};

export const GET_ROLE_BY_ID = async (
  roleId: string
): Promise<AxiosResponse<RoleResponse>> => {
  const endpoint = roleEndpoints.getRoleById.replace(':id', roleId);
  const response = await jobBoardAPI.get(endpoint);
  return response.data;
};

export const CREATE_ROLE = async (
  data: RoleDTO
): Promise<AxiosResponse<RoleResponse>> => {
  const response = await jobBoardAPI.post(roleEndpoints.create, data);
  return response.data;
};

export const UPDATE_ROLE = async ({
  roleId,
  data
}: {
  roleId: string;
  data: RoleDTO;
}): Promise<AxiosResponse<RoleResponse>> => {
  const endpoint = roleEndpoints.update.replace(':id', roleId);
  return jobBoardAPI.patch(endpoint, data);
};

export const DELETE_ROLE = async (
  roleId: string
): Promise<AxiosResponse<RoleResponse>> => {
  const endpoint = roleEndpoints.delete.replace(':id', roleId);
  return jobBoardAPI.delete(endpoint);
};

export const GET_ALL_PERMISSIONS = async (): Promise<
  AxiosResponse<PermissionResponse[]>
> => {
  const response = await jobBoardAPI.get(roleEndpoints.getAllPermissions);
  return response.data;
};

export const GET_ROLE_DETAIL = async (
  roleId: string
): Promise<{ data: RolePermissionsApiResponse }> => {
  const endpoint = roleEndpoints.getRoleDetail(roleId);
  const response = await jobBoardAPI.get<RolePermissionsApiResponse>(endpoint);
  return { data: response.data };
};
